import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { RequireRole } from '@/core/permissions';

const CoursesPage = lazy(() =>
  import('./pages/CoursesPage').then(m => ({ default: m.CoursesPage }))
);
const CourseDetailPage = lazy(() =>
  import('./pages/CourseDetailPage').then(m => ({ default: m.CourseDetailPage }))
);
const LessonViewPage = lazy(() =>
  import('./pages/LessonViewPage').then(m => ({ default: m.LessonViewPage }))
);
const LessonEditorPage = lazy(() =>
  import('./pages/LessonEditorPage').then(m => ({ default: m.LessonEditorPage }))
);
const CalendarPage = lazy(() =>
  import('./pages/CalendarPage').then(m => ({ default: m.CalendarPage }))
);

/** In-shell curriculum pages. Parents have no curriculum surface yet (the
 *  backend returns none/403 for them — ADR-011); the gates mirror that.
 *  Authoring (the lesson editor) is staff-only. */
export const curriculumRoutes = (
  <>
    <Route element={<RequireRole roles={['admin', 'teacher', 'pupil']} />}>
      <Route path="/courses" element={<CoursesPage />} />
      <Route path="/courses/:publicId" element={<CourseDetailPage />} />
      <Route path="/lessons/:publicId" element={<LessonViewPage />} />
      <Route path="/calendar" element={<CalendarPage />} />
    </Route>
    <Route element={<RequireRole roles={['admin', 'teacher']} />}>
      <Route path="/lessons/:publicId/edit" element={<LessonEditorPage />} />
    </Route>
  </>
);
